<multi-selector
  [nodes]="nodes"
  [selectedItemPartial]="selectedParentItem"
  [sessionIds]="sessionIds"
  [uiId]="uiId"
  [placeholder]="placeholder"
  [readonly]="readonly"
  [disabled]="disabled"
  [borderless]="borderless"
  [a11yLabelledby]="a11yLabelledby"
  [a11yRequired]="a11yRequired"
  [isSmartAlignmentAvailable]="isSmartAlignmentAvailable"
  [searchFunctionPlaceholder]="searchFn"
  [sortFunctionPlaceholder]="sortFn"
  [nodesLoading]="nodesLoading"
  (valueUpdate)="updateValue($event)"
  (trackingParamsUpdate)="setTrackingParams($event)"
  (openChange)="onOpenChange($event)"
  (isScrollUsed)="scrollIsUsed($event)">
</multi-selector>
